import { Select, SelectProps } from "@mui/material";

export const FilterSelect = (props: SelectProps<string>) => {
  const { sx, ...otherProps } = props;
  return (
    <Select
      {...otherProps}
      sx={{
        background: "white",
        ...sx,
      }}
    />
  );
};
